// extracted by mini-css-extract-plugin
export default {"main":"main_main__IjKCx","board":"main_board__V3W8Q","column":"main_column__ktp7Q"};